import React from 'react'
import gql from 'graphql-tag'
import { ANALYTICS_LINK_FRAGMENT } from '@/fragments'
import { useGlobalContext } from '@/components/context'
import ValueMetric from '../../types/value'
import MetricPlaceholder from '../metric-placeholder'
import { useSpecificMetricQuery } from './__gen'


gql`
	query specificMetric($id: ID!, $teamId: ID, $isSuiteAdminDashboard: Boolean) {
		specificMetric(id: $id) {
			id
			name
			result(teamId: $teamId, isSuiteAdminDashboard: $isSuiteAdminDashboard) {
				value
				formLink {
					...MetricFormLinkEssentials
				}
			}
		}
	}
	${ANALYTICS_LINK_FRAGMENT}
`


type Props = {
	id: string
	isSuiteAdminDashboard?: boolean
}

const SpecificMetricWrapper = ({ id, isSuiteAdminDashboard }: Props) => {
	const globalContext = useGlobalContext()
	const { loading, data } = useSpecificMetricQuery({
		variables: {
			id,
			teamId: globalContext.currentTeam?.id,
			isSuiteAdminDashboard,
		}
	})
	if (loading) {
		return <MetricPlaceholder />
	}
	if (!data || !data.specificMetric) {
		return <div>error</div>
	}
	return (
		<ValueMetric isSuiteAdminDashboard={isSuiteAdminDashboard} {...data?.specificMetric} />
	)

}

export default SpecificMetricWrapper